import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './CompleteDenture.css';

const CompleteDenture = () => {
    const pricing = [
        { type: "New Ace (U/L)", price: "₱5,500" },
        { type: "New Ace FX", price: "₱8,500 - ₱9,500" },
        { type: "Natura Tone (U/L)", price: "₱12,500", },
        { type: "New Ace (US) (U/L)", price: "₱20,000" },
        { type: "Biotone (U/L)", price: "₱25,000" },
        { type: "Bioform (U/L)", price: "₱25,000" },
        { type: "Ivocap (U/L)", price: "₱25,000" },
        { type: "Thermosens (U/L)", price: "₱25,000" },
    
    ];

    return (
        <>
        <Header />
        <div className="completedenture-container">
            <div className="completedenture-content">
                <h1> COMPLETE DENTURE</h1>
                <p>
                This is the most common type of dental bridge. It consists of dental crowns (caps) on both ends with pontics 
                (artificial teeth) in between. A dentist bonds the crowns to your natural teeth (abutments) on either side of the gap, 
                and the artificial teeth (pontics) fill in the space between.
                </p>
                <h2>Pricing</h2>
                <table className="completedenture-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};


export default CompleteDenture;